import { render, staticRenderFns } from "./SummaryOrder.vue?vue&type=template&id=0bb66d47&"
import script from "./SummaryOrder.vue?vue&type=script&lang=js&"
export * from "./SummaryOrder.vue?vue&type=script&lang=js&"
import style0 from "./SummaryOrder.vue?vue&type=style&index=0&id=0bb66d47&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports